<!--
  工单详情追踪日志
-->
<template>
  <div class="my-table">
    <el-table :data="list">
      <el-table-column
        label="追踪时间"
        prop="followTime"
        show-overflow-tooltip
        width="200px"
      ></el-table-column>
      <el-table-column
        label="追踪人"
        prop="followName"
        show-overflow-tooltip
        width="200px"
      ></el-table-column>
      <el-table-column
        label="追踪内容"
        prop="followContent"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      list: []
    }
  },
  computed: {},
  watch: {},
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      this.$api.order.sheetFollowLogList(this.id).then(({ data }) => {
        if (data.code == 200) {
          this.list = data.data
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.my-table {
  margin-top: 35px;
}
</style>
